import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import './styles/index.css';

// Suppress ResizeObserver loop error overlay in dev (Chrome issue)
if (typeof window !== 'undefined') {
  const resizeObserverErr = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
  window.addEventListener('error', (event) => {
    if (resizeObserverErr.test(event.message)) {
      event.stopImmediatePropagation();
    }
  });
  if (process.env.NODE_ENV !== 'production') {
    const originalConsoleError = console.error;
    console.error = (...args) => {
      if (typeof args[0] === 'string' && resizeObserverErr.test(args[0])) {
        return;
      }
      originalConsoleError(...args);
    };
  }
}

const app = (
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

createRoot(document.getElementById('root')).render(app);
